<script>
import ElDialog from './Dialog.vue';

export default {
  components: { ElDialog },
  data() {
    return {
      compareModal: false,
    }
  },
}
</script>
